export const TAG_PICKER_SEARCH_TAGS = "TAG_PICKER_SEARCH_TAGS";
export const TAG_PICKER_SEARCH_TAGS_RESPONSE = "TAG_PICKER_SEARCH_TAGS_RESPONSE";